import React, { useEffect, useState } from "react";
import { withFirebase } from "../../services";
import ConversationList from "./ConversationList";
import ChatWindow from "./ChatWindow";
import ComposeInmail from "./ComposeInmail";
import DraftList from "./DraftList";

const MenuButton = ({ label, active, onClick }) => (
  <button
    onClick={onClick}
    style={{
      width: "100%",
      background: "transparent",
      border: "none",
      textAlign: "left",
      padding: "12px 16px",
      cursor: "pointer",
      fontSize: "15px",
      borderRadius: "8px",
      color: active ? "#1976d2" : "#444",
      fontWeight: active ? "600" : "400",
    }}
  >
    {label}
  </button>
);

const InmailContainer = ({ firebase }) => {
  const [conversations, setConversations] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState("inbox");
  const [userMap, setUserMap] = useState({});
  const [isUserMapLoading, setIsUserMapLoading] = useState(true);
  const [drafts, setDrafts] = useState([]);
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [sentConversations, setSentConversations] = useState([]);
    

  const currentEmail = firebase.auth.currentUser.email;

useEffect(() => {
debugger;
  const unsubscribe = firebase.db
    .collection("mailDrafts")
    .where(
      "senderEmail",
      "==",
      currentEmail
    )
    .orderBy("updatedAt", "desc")
    .onSnapshot((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDrafts(data);
    });

  return unsubscribe;
}, [firebase, currentEmail]);

useEffect(() => {
  const providerRef = firebase.db
    .collection("inmail")
    .where("providerId", "==", currentEmail);

  const userRef = firebase.db
    .collection("inmail")
    .where("userId", "==", currentEmail);

  let providerData = [];
  let userData = [];

  const mergeAndSet = async  () => {
    const merged = [
      ...new Map(
        [...providerData, ...userData].map((x) => [
          x.id,
          x,
        ])
      ).values(),
    ];

    merged.sort((a, b) => {
      const aTime =
        a.lastMessageAt?.toMillis?.() ||
        new Date(a.lastMessageAt || 0).getTime();

      const bTime =
        b.lastMessageAt?.toMillis?.() ||
        new Date(b.lastMessageAt || 0).getTime();

      return bTime - aTime;
    });

    const inbox = [];
const sent = [];

await Promise.all(
  merged.map(async (conv) => {
    const snap = await firebase.db
      .collection("inmail")
      .doc(conv.id)
      .collection("messages")
      .get();

    const messages = snap.docs.map((d) =>
      d.data()
    );

    const hasIncomingMessage =
      messages.some(
        (m) =>
          m.senderId !== currentEmail
      );

    if (hasIncomingMessage) {
      inbox.push(conv);
    } else {
      sent.push(conv);
    }
  })
);

setConversations(inbox);
setSentConversations(sent);
  };

  const unsubscribeProvider = providerRef.onSnapshot(
    (snapshot) => {
      providerData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      mergeAndSet();
    }
  );

  const unsubscribeUser = userRef.onSnapshot(
    (snapshot) => {
      userData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      mergeAndSet();
    }
  );

  return () => {
    unsubscribeProvider();
    unsubscribeUser();
  };
}, [currentEmail, firebase]);

useEffect(() => {
  if (!conversations.length) {
    setUserMap({});
    setIsUserMapLoading(false);
    return;
  }

  const fetchNames = async () => {
    setIsUserMapLoading(true);

    const map = {};

    await Promise.all(
      conversations.map(async (conv) => {
        const email =
          conv.providerId === currentEmail
            ? conv.userId
            : conv.providerId;

        if (!map[email]) {
          const snap = await firebase.db
            .collection("healthCareProfessionals")
            .where("email", "==", email)
            .get();

          if (snap.empty) {
            map[email] = {
              email,
              name: email,
              headshotURL: "",
            };
          } else {
            const data = snap.docs[0].data();

            map[email] = {
              email,
              name: data.name || email,
              headshotURL:
                data.headshotURL || "",
            };
          }
        }
      })
    );

    setUserMap(map);
    setIsUserMapLoading(false);
  };

  fetchNames();
}, [conversations, firebase, currentEmail]);

  const urgentConversations = conversations.filter(
    (c) => c.urgent === true
  );
  
  const renderRightPanel = () => {
    switch (selectedFolder) {
      case "inbox":
        return selectedChat ? (
          <div style={{ height: "100%" }}>
            <div
              style={{
                padding: "12px",
                borderBottom: "1px solid #e0e0e0",
                background: "#fff",
              }}
            >
              <button
                onClick={() => setSelectedChat(null)}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  fontSize: "15px",
                }}
              >
                ← Back to Inbox
              </button>
            </div>

            <ChatWindow
              selectedChat={selectedChat}
              firebase={firebase}
              userMap={userMap}
            />
          </div>
        ) : (
          <ConversationList
  conversations={conversations}
  userMap={userMap}
  currentEmail={currentEmail}
  selectedChat={selectedChat}
  onSelect={setSelectedChat}
  title="Inbox"
/>
        );

case "urgent":
  return selectedChat ? (
    <div style={{ height: "100%" }}>
      <div
        style={{
          padding: "12px",
          borderBottom: "1px solid #e0e0e0",
          background: "#fff",
        }}
      >
        <button
          onClick={() => setSelectedChat(null)}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          ← Back to Urgent
        </button>
      </div>

      <ChatWindow
        selectedChat={selectedChat}
        firebase={firebase}
        userMap={userMap}
      />
    </div>
  ) : (
    <ConversationList
      conversations={urgentConversations}
      userMap={userMap}
      currentEmail={currentEmail}
      selectedChat={selectedChat}
      onSelect={setSelectedChat}
      title = "Urgent"
    />
  );
      case "drafts":
  return selectedDraft ? (
    <ComposeInmail
      firebase={firebase}
      draft={selectedDraft}
      onClose={() => {
        setSelectedDraft(null);
      }}
    />
  ) : (
    <DraftList
      drafts={drafts}
      onSelect={setSelectedDraft}
    />
  );
  case "sent":
  return selectedChat ? (
    <div style={{ height: "100%" }}>
      <div
        style={{
          padding: "12px",
          borderBottom:
            "1px solid #e0e0e0",
          background: "#fff",
        }}
      >
        <button
          onClick={() =>
            setSelectedChat(null)
          }
          style={{
            border: "none",
            background:
              "transparent",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          ← Back to Sent
        </button>
      </div>

      <ChatWindow
        selectedChat={selectedChat}
        firebase={firebase}
        userMap={userMap}
      />
    </div>
  ) : (
    <ConversationList
      conversations={sentConversations}
      userMap={userMap}
      currentEmail={currentEmail}
      selectedChat={selectedChat}
      onSelect={setSelectedChat}
      title="Sent"
    />
  );    
  case "compose":
        return (
          <ComposeInmail
            firebase={firebase}
            onClose={() => setSelectedFolder("inbox")}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "700px",
        background: "#fff",
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    >
      {/* LEFT SIDEBAR */}
      <div
        style={{
          width: "30%",
          borderRight: "1px solid #e0e0e0",
          padding: "20px",
          background: "#fafafa",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <button
        onClick={() => {
                  setSelectedFolder("compose");
                  setSelectedChat(null);
                }}
          style={{
            padding: "14px",
            borderRadius: "25px",
            border: "1px solid #dadce0",
            background: "#fff",
            cursor: "pointer",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          + Compose
        </button>

        <MenuButton
          label="Inbox"
          active={selectedFolder === "inbox"}
          onClick={() => {
            setSelectedFolder("inbox");
            setSelectedChat(null);
            
        setSelectedDraft(null);
          }}
        />

        <MenuButton
          label="Urgent"
          active={selectedFolder === "urgent"}
          onClick={() => {
            setSelectedFolder("urgent");
            setSelectedChat(null);
        setSelectedDraft(null);
          }}
        />

        <MenuButton
          label="Drafts"
          active={selectedFolder === "drafts"}
          onClick={() => {
            setSelectedFolder("drafts");
            setSelectedChat(null);
          }}
        />

        <MenuButton
          label="Sent"
          active={selectedFolder === "sent"}
          onClick={() => {
            setSelectedFolder("sent");
            setSelectedChat(null);
          }}
        />
      </div>

      {/* RIGHT CONTENT */}
      <div
        style={{
          width: "70%",
          background: "#fff",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isUserMapLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
      }}
    >
      Loading...
    </div>
  ) : (
    
    renderRightPanel()
  )}
      </div>
    </div>
  );
};

export default withFirebase(InmailContainer);